import React from "react";
import { CCol, CFormGroup, CInput, CLabel, CRow } from "@coreui/react";
import { useRemissionNoteFormContext } from "../context/RemissionNoteFormContext";
import { getFieldErrors } from "../../../models/errors";
import { FieldErrors } from "../../form/FieldErrors";

const SectionDivider: React.FC<{ icon: string; label: string }> = ({ icon, label }) => (
  <div style={{ display: "flex", alignItems: "center", marginBottom: "16px", marginTop: "16px" }}>
    <div style={{ width: "4px", height: "18px", background: "#006657", borderRadius: "2px", marginRight: "10px", flexShrink: 0 }} />
    <i className={`fa ${icon} mr-2`} style={{ fontSize: "0.85rem", color: "var(--theme-accent)" }}></i>
    <h6 style={{ margin: 0, fontWeight: 600, color: "var(--theme-muted)", fontSize: "0.78rem", textTransform: "uppercase", letterSpacing: "0.8px" }}>
      {label}
    </h6>
    <div style={{ flex: 1, height: "1px", background: "var(--theme-divider)", marginLeft: "10px" }} />
  </div>
);

const FormLabel: React.FC<{ required?: boolean; children: React.ReactNode }> = ({ required, children }) => (
  <CLabel className="mb-0" style={{ fontWeight: 600, fontSize: "0.875rem", color: "var(--theme-text-soft)" }}>
    {required && <span className="text-danger mr-1">*</span>}
    {children}
  </CLabel>
);

export const RemissionNoteFormCarrierDriverSection: React.FC = () => {
  const {
    remissionNoteRef,
    errors,
    onCarrierRucChange,
    onCarrierSocialNameChange,
    onCarrierAddressChange,
    onDriverDocumentNumberChange,
    onDriverNameChange,
    onDriverAddressChange,
  } = useRemissionNoteFormContext();

  return (
    <>
      <SectionDivider icon="fa-building" label="Datos del Transportista" />
      <CFormGroup>
        <CRow className="align-items-center">
          <CCol md={2}>
            <FormLabel required>RUC:</FormLabel>
          </CCol>
          <CCol md={2}>
            <CInput
              type="text"
              defaultValue={
                remissionNoteRef.current
                  ? remissionNoteRef.current.carrierRuc
                  : ""
              }
              onChange={onCarrierRucChange}
              placeholder="RUC"
            ></CInput>
            <FieldErrors
              errors={getFieldErrors("carrierRuc", errors) as string[]}
            ></FieldErrors>
          </CCol>
          <CCol md={2}>
            <FormLabel required>Razón Social:</FormLabel>
          </CCol>
          <CCol md={6}>
            <CInput
              type="text"
              defaultValue={
                remissionNoteRef.current
                  ? remissionNoteRef.current.carrierSocialName
                  : ""
              }
              onChange={onCarrierSocialNameChange}
              placeholder="Razón Social"
            ></CInput>
            <FieldErrors
              errors={getFieldErrors("carrierSocialName", errors) as string[]}
            ></FieldErrors>
          </CCol>
        </CRow>
      </CFormGroup>
      <CFormGroup>
        <CRow className="align-items-center">
          <CCol md={2}>
            <FormLabel required>Dirección:</FormLabel>
          </CCol>
          <CCol md={6}>
            <CInput
              type="text"
              defaultValue={
                remissionNoteRef.current
                  ? remissionNoteRef.current.carrierAddress
                  : ""
              }
              onChange={onCarrierAddressChange}
              placeholder="Dirección"
            ></CInput>
            <FieldErrors
              errors={getFieldErrors("carrierSocialName", errors) as string[]}
            ></FieldErrors>
          </CCol>
        </CRow>
      </CFormGroup>

      <div style={{ display: "flex", alignItems: "center", margin: "12px 0 14px" }}>
        <div style={{ width: "3px", height: "14px", background: "#006657", borderRadius: "2px", marginRight: "8px", opacity: 0.5 }} />
        <span style={{ fontWeight: 600, fontSize: "0.75rem", color: "var(--theme-muted)", textTransform: "uppercase", letterSpacing: "0.6px" }}>
          Datos del Conductor
        </span>
        <div style={{ flex: 1, height: "1px", background: "var(--theme-divider)", marginLeft: "8px" }} />
      </div>

      <CFormGroup>
        <CRow className="align-items-center">
          <CCol md={2}>
            <FormLabel required>Nro. Documento:</FormLabel>
          </CCol>
          <CCol md={2}>
            <CInput
              type="text"
              defaultValue={
                remissionNoteRef.current
                  ? remissionNoteRef.current.driverDocumentNumber
                  : ""
              }
              onChange={onDriverDocumentNumberChange}
              placeholder="Documento"
            ></CInput>
            <FieldErrors
              errors={
                getFieldErrors("driverDocumentNumber", errors) as string[]
              }
            ></FieldErrors>
          </CCol>
          <CCol md={2}>
            <FormLabel required>Nombre:</FormLabel>
          </CCol>
          <CCol md={6}>
            <CInput
              type="text"
              defaultValue={
                remissionNoteRef.current
                  ? remissionNoteRef.current.driverName
                  : ""
              }
              onChange={onDriverNameChange}
              placeholder="Nombre"
            ></CInput>
            <FieldErrors
              errors={getFieldErrors("driverName", errors) as string[]}
            ></FieldErrors>
          </CCol>
        </CRow>
      </CFormGroup>
      <CFormGroup>
        <CRow className="align-items-center">
          <CCol md={2}>
            <FormLabel required>Dirección:</FormLabel>
          </CCol>
          <CCol md={6}>
            <CInput
              type="text"
              defaultValue={
                remissionNoteRef.current
                  ? remissionNoteRef.current.driverAddress
                  : ""
              }
              onChange={onDriverAddressChange}
              placeholder="Dirección"
            ></CInput>
            <FieldErrors
              errors={getFieldErrors("driverAddress", errors) as string[]}
            ></FieldErrors>
          </CCol>
        </CRow>
      </CFormGroup>
    </>
  );
};
